import React from 'react';
import { useHorizontalScrollThumb } from '../hooks/useHorizontalScrollThumb';
import './MobileScrollRail.css';

/**
 * Always-visible horizontal scroll indicator for touch / mobile Chrome (native bar is overlay-only).
 */
export function MobileScrollRail({ scrollerRef }) {
  const thumbStyle = useHorizontalScrollThumb(scrollerRef);
  return (
    <div className="mobile-scroll-rail" aria-hidden="true">
      <div className="mobile-scroll-rail__thumb" style={thumbStyle} />
    </div>
  );
}
